import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumb navigation component
 * Shows hierarchical navigation path
 */
const Breadcrumb = ({ items }) => {
  return (
    <nav
      aria-label="Breadcrumb"
      className="border-b border-white/5"
      data-testid="breadcrumb"
    >
      <div className="editorial-container py-4">
        <ol className="flex items-center gap-2 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            
            return (
              <li key={index} className="flex items-center gap-2">
                {index > 0 && (
                  <ChevronRight 
                    className="w-3.5 h-3.5 text-brand-cream/25" 
                    aria-hidden="true"
                  />
                )}
                {isLast ? (
                  <span
                    className="font-sans text-brand-cream/50"
                    aria-current="page"
                    data-testid={`breadcrumb-item-${index}`}
                  >
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.href}
                    className="font-sans text-brand-cream/65 hover:text-brand-gold transition-colors"
                    data-testid={`breadcrumb-link-${index}`}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
